<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'DELIVERY|Podgląd podpisu potwierdzającego dostarczenie:' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-horizontal w-100">
            <img
                [src]="data.signatureImage"
                alt="Podpis"
                class="signature"
            >
        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>